import React, { useCallback, useEffect, useState } from 'react';
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
  addEdge,
  useNodesState,
  useEdgesState
} from 'reactflow';
import 'reactflow/dist/style.css';

import Sidebar from '../components/Sidebar';
import NodeEditorPanel from '../components/NodeEditorPanel';
import { loadPredefinedFlow } from '../utils/flowLoader';

let id = 1;
const getId = () => `${id++}`;

const Editor = () => {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [selectedNode, setSelectedNode] = useState(null);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    []
  );

  const handleAddNode = (type) => {
    const newNode = {
      id: getId(),
      type: 'default',
      data: { label: `${type} ${id - 1}`, type: type, configJson: '{}' },
      position: {
        x: Math.random() * 300 + 100,
        y: Math.random() * 300 + 100
      }
    };
    setNodes((nds) => [...nds, newNode]);
  };

  const handleLoadPredefinedFlow = (key) => {
    const flow = loadPredefinedFlow(key);
    console.log('🧲 Cargando flujo local:', flow);
    if (flow) {
      setNodes(flow.nodes);
      setEdges(flow.edges);
    }
  };

  const onNodeClick = (_event, node) => {
    setSelectedNode(node);
  };

  const handleSaveNode = (nodeId, updatedData) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === nodeId ? { ...node, data: { ...updatedData } } : node
      )
    );
    setSelectedNode(null);
  };

  return (
    <div className="columns is-gapless is-fullheight">
      <Sidebar
        onAddNode={handleAddNode}
        onLoadPredefinedFlow={handleLoadPredefinedFlow}
        onSaveFlow={() => console.log('🔐 Guardar flujo (a futuro)')}
      />

      <div className="column is-7">
        <div className="is-relative">
          <div className="is-flex is-justify-content-flex-start is-align-items-center p-3">
            <div className="buttons">
              <button
                className="button is-primary"
                onClick={() =>
                  console.log('📝 Exportar: ', JSON.stringify({ nodes, edges }, null, 2))
                }
              >
                Exportar Flujo
              </button>

              <label className="button is-link ml-2">
                Importar Flujo
                <input
                  type="file"
                  accept="application/json"
                  className="is-hidden"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      try {
                        const parsed = JSON.parse(event.target.result);
                        setNodes(parsed.nodes || []);
                        setEdges(parsed.edges || []);
                      } catch (error) {
                        alert('❌ Archivo inválido');
                      }
                    };
                    if (file) reader.readAsText(file);
                  }}
                />
              </label>

              <button
                className="button is-primary ml-2"
                onClick={() => {
                  localStorage.setItem(
                    'previewFlow',
                    JSON.stringify({ nodes, edges })
                  );
                  window.open('/preview', '_blank');
                }}
              >
                Previsualizar
              </button>

              <label className="button is-info ml-2">
                Importar desde Draw.io
                <input
                  type="file"
                  accept=".drawio,.xml"
                  className="is-hidden"
                  onChange={() => alert('🛠️ Funcionalidad pendiente')}
                />
              </label>
            </div>
          </div>

          <div style={{ height: 'calc(100vh - 50px)' }}>
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onNodeClick={onNodeClick}
              fitView
            >
              <MiniMap />
              <Controls />
              <Background gap={12} size={1} />
            </ReactFlow>
          </div>
        </div>
      </div>

      <div className="column is-3 p-4 bg-white shadow-md overflow-y-auto">
        <NodeEditorPanel
          selectedNode={selectedNode}
          onSave={handleSaveNode}
          onClose={() => setSelectedNode(null)}
        />
      </div>
    </div>
  );
};

export default Editor;
